import React from 'react';
import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';

const Page500 = () => {
    const { t } = useTranslation()

    return (
        <Result
            status="500"
            title="Oops!"
            subTitle={t("error.subtitle500")}
            extra={
                <Button
                    type="primary"
                    onClick={() => window.location.reload()}
                >
                    {t("error.retry")}
                </Button>
            }
        />
    );
}

export default Page500;